const overlayElement  = document.querySelector('.cart-popout-overlay')
const cartModal       = document.querySelector('.cart-modal')
const closeCartIcon   = document.querySelector('.cart-modal__close')
const cartInModalIcon = document.querySelector('.cart-icon-container')
const removeChips     = document.querySelectorAll('.remove-chip')
const track           = document.querySelector('.track')
const slides          = document.querySelectorAll('.mini-product-card')

let slideIndex      = 1
let initialPosition = null
let moving          = false
let transform       = 0

closeCartIcon.onclick = closeCartModal

function gestureStart(event) {
  const transformMatrix = window.getComputedStyle(track).getPropertyValue('transform')

  initialPosition = event.pageX
  moving          = true

  if (transformMatrix !== 'none') {
    transform = parseInt(transformMatrix.split(',')[4].trim())
  }
}

function gestureMove(event) {
  if (moving) {
    const currentPosition = event.pageX
    const diff            = currentPosition - initialPosition

    track.style.transform = `translateX(${transform + diff}px)`
  }
}

function gestureEnd(event) {
  moving = false
}

function attachEventListeners() {
  if (window.PointerEvent) {
    window.addEventListener('pointerdown', gestureStart)
  
    window.addEventListener('pointermove', gestureMove)
  
    window.addEventListener('pointerup', gestureEnd)
  } else {
    window.addEventListener('touchdown', gestureStart)
  
    window.addEventListener('touchmove', gestureMove)
  
    window.addEventListener('touchup', gestureEnd)
  
    window.addEventListener('mousedown', gestureStart)
  
    window.addEventListener('mousemove', gestureMove)
  
    window.addEventListener('mouseup', gestureEnd)
  }

  document.querySelector('#cart-slider') && document.querySelector('#cart-slider').addEventListener('click', function (event) {
    document.querySelector('#cart').submit()
  })
}

function isIE() {
    const ua      = window.navigator.userAgent
    const msie    = ua.indexOf('MSIE ')
    const trident = ua.indexOf('Trident/')

    return msie > 0 || trident > 0
}

async function getCart() {
  let data = null
  try {
    let result = await fetch('/cart.js')
    data = await result.json()
  } catch (error) {
    throw error
  }

  return data
}

async function updateCart(updateObj) {
  let data = null
  try {
    let result = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateObj)
    })

    data = await result.json()
  } catch (error) {
    throw error
  }

  return data
}

async function postToCart(itemsObj) {
  let data = null

  try {
    let result = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemsObj)
    })

    data = await result.json()
  } catch (error) {
    throw error
  }

  return data
}

async function getProductInfo(handle) {
  if (!handle) {
    throw Error('No product handle provided.')
  }

  let url = `/products/${handle}.json`
  let data = null

  try {
    let result = await fetch(url)
    data = await result.json()
  } catch (error) {
    throw error
  }

  return data && data.product
}

async function getRecommendedProducts(productId) {
  let url  = `/recommendations/products.json?product_id=${productId}&limit=3`
  let data = null

  try {
    let result = await fetch(url)
    data = await result.json()
  } catch (error) {
    throw error
  }

  return data && data.products
}

async function getProductVariantInfo(variantId) {
  let url = `/variants/${variantId}.json`
  let data = null

  try {
    let result = await fetch(url)
    data = await result.json()
  } catch (error) {
    throw error
  }

  return data && data.product_variant
}

async function getMetafields(resource, id) {
  let url  = `${domains.loyalty_url}/shopify/metafields`
  let data = null

  if (resource && id) {
    url += `/${resource}/${id}`
  }

  try {
    let result = await fetch(url)
    let jsonData = await result.json()
    data = jsonData && jsonData.result
  } catch (error) {
    throw error
  }

  return data
}

async function getMultiplier() {
  let multiplier = null
  try {
    let metafields = await getMetafields()
    multiplier = metafields && metafields.find(field => field.key == 'points_multiplier' && field.owner_resource == 'shop')
  } catch (error) {
    throw error
  }

  return multiplier && multiplier.value
}

async function getVariantPoints(id) {
  let metafields = []
  let points = null

  try {
    metafields = await getMetafields('variant', id)
    points = metafields && metafields.find(field => field.key == 'points' && field.owner_id == id)
  } catch (error) {
    throw error
  }

  return points && points.value
}

async function removeProduct(variantId, self) {
  const productIdentifier = `.product-variant-${variantId}`
  const updateObj = {
    updates: {}
  }
  const productQuantityEl = document.querySelector(`${productIdentifier} .quantity-value`)
  const productQuantity   = productQuantityEl.innerText

  updateObj['updates'][variantId] = 0

  let listIds = [variantId] 
  if (self) {
    const handle = self.getAttribute('handle')
    listIds = [...document.querySelectorAll(`.quantity-value[handle="${handle}"]`)].map(item => +item.getAttribute('id'))
    listIds.forEach(id => {
      updateObj['updates'][id] = 0
    })
  }

  const currentCart = await updateCart(updateObj)
  for (let i = 0; i < listIds.length; i++ ){
    const variantId = listIds[i]
    updateProductValues(variantId, null, currentCart)
  }
  updateCartPoints()
  updateRewardPoints()
  updateTotalPrice()
}

function adjustContianerHeight(itemsAmount = 1) {
  const mainCartContainer   = document.querySelector('.cart-main-container')
  const productsDisplay     = document.querySelector('.products-display')

  if (itemsAmount > 1) {
    if (mainCartContainer.classList.value.includes('full-height') && productsDisplay.classList.value.includes('full-height')) {
      mainCartContainer.classList.remove('full-height')
      productsDisplay.classList.remove('full-height')
    }
  }

  if (itemsAmount <= 1) {
    if (!mainCartContainer.classList.value.includes('full-height') && !productsDisplay.classList.value.includes('full-height')) {
      mainCartContainer.classList.add('full-height')
      productsDisplay.classList.add('full-height')
    }
  }
}

function adjustCartPoints(operation, amount = 1) {
  const operations         = ['add', 'subtract']
  const cartPoints         = document.querySelector('.cart-points')
  const cartPointsSpan     = document.querySelector('.cart-points span')
  const mainCartPoints     = document.querySelector('.cart-count-bubble')
  const mainCartPointsSpan = document.querySelector('.cart-count-bubble span')
  let cartItemCount = null

  if (!operations.includes(operation)) {
    console.error('adjustCartPoints can only take add or subtract for an operation')
  }

  if (operation === 'subtract') {
    cartItemCount = cartPointsSpan ? parseInt(cartPointsSpan.innerText, 10) - parseInt(amount, 10) : 0

    if (cartPointsSpan.innerText == '1') {
      cartPoints.remove()
      mainCartPoints.remove()

      return null
    }
  } else {
    cartItemCount = cartPointsSpan ? parseInt(cartPointsSpan.innerText, 10) + parseInt(amount, 10) : 0
  }

  cartPointsSpan.innerText     = cartItemCount
  mainCartPointsSpan.innerText = cartItemCount
}

function updateCartPoints() {
  const productCards   = document.querySelectorAll('.product-card')
  const cartPoints     = document.querySelector('.cart-points span')
  const mainCartPoints = document.querySelector('.cart-count-bubble span')
  let quantity         = 0

  for (let productCard of productCards) {
    let productQuantityElement = productCard.querySelector('.quantity-control .quantity-value')
    let productQuantity = parseInt(productQuantityElement.innerText, 10)

    quantity += productQuantity
  }

  cartPoints.innerText = quantity
  mainCartPoints.innerText = quantity
}

function updateRewardPoints() {
  const productCards   = document.querySelectorAll('.product-card')
  const pointInfoElement    = document.querySelector('.cart-modal .point-info')
  const totalPointsBadge    = document.querySelector('.cart-modal .point-info points-badge')
  const newTotalPointsBadge = document.createElement('points-badge')
  let points = 0
  let multiplier = 1
  let totalPoints = 0

  if (totalPointsBadge) {
    totalPointsBadge.remove()
  }

  for (let productCard of productCards) {
    let productQuantityElement = productCard.querySelector('.quantity-control .quantity-value')
    let productQuantity = parseInt(productQuantityElement.innerText, 10)
    let productPointsElement = productCard.querySelector('points-badge')
    let productPoints = productPointsElement ? parseInt(productPointsElement.points , 10) : 0
    if (productPointsElement && productPointsElement.multiplier && Number(productPointsElement.multiplier) !== NaN && productPointsElement.multiplier !== 'undefined') {
      multiplier = parseInt(productPointsElement.multiplier, 10)
    }

    points = (productPoints * productQuantity) * multiplier

    totalPoints += points
  }

  if (currentCustomer) {
    if (!currentCustomer.tags.includes('Insider') && !currentCustomer.tags.includes('Insider_trial') && !currentCustomer.tags.includes('Rewards') && !currentCustomer.tags.includes('Explorer') && !currentCustomer.tags.includes('Explorer_trial') && !currentCustomer.tags.includes('Business_members') && !currentCustomer.tags.includes('Insider_plus')) {
      newTotalPointsBadge.setAttribute('disabled', true)
    } else {
      newTotalPointsBadge.setAttribute('disabled', false)
    }
  }

  if (!currentCustomer) {
    newTotalPointsBadge.setAttribute('disabled', true)
  }

  newTotalPointsBadge.setAttribute('points', totalPoints)
  pointInfoElement.append(newTotalPointsBadge)
}

async function updateProductPoints(variantId, productTags, metafields) {
  const productCard = document.querySelector(`.product-variant-${variantId}`)
  const productBadge = document.createElement('points-badge')
  const productSaleDetails =  productCard.querySelector('.product-sale-details')
  const loader = document.createElement('span')
  loader.setAttribute('class', 'loader')
  console.log('metafields ---------> ', metafields)

  productCard.querySelector('points-badge').remove()
  productSaleDetails.prepend(loader)

  if (currentCustomer) {
    if (!currentCustomer.tags.includes('Insider') && !currentCustomer.tags.includes('Insider_trial') && !currentCustomer.tags.includes('Rewards') && !currentCustomer.tags.includes('Explorer') && !currentCustomer.tags.includes('Explorer_trial') && !currentCustomer.tags.includes('Business_members') && !currentCustomer.tags.includes('Insider_plus')) {
      productBadge.setAttribute('disabled', true)
    } else {
      productBadge.setAttribute('disabled', false)
    }
  }

  if (!currentCustomer) {
    productBadge.setAttribute('disabled', true)
  }

  try {
    let product = await getProductVariantInfo(variantId)
    let multiplier = metafields.ghs.multiplier || pointMultiplier
    let points =  await getVariantPoints(variantId)
    if (!points) {
      points = metafields.ghs.points || 0
    }

    if (productTags.includes('XPOINTS')) {
      multiplier = productTags.split(',').find(tag => tag.includes('XPOINTS')).split('XPOINTS')[0]
    }

    if (product.compare_at_price && product.compare_at_price != product.price) {
      productBadge.setAttribute('points', '0')
      productBadge.setAttribute('points-classification', 'sale item')
      productBadge.disabled = false
    } else if (productTags.includes('nopoints')) {
      productBadge.setAttribute('points', '0')
      productBadge.setAttribute('multiplier', multiplier)
    } else {
      productBadge.setAttribute('points', points)
      productBadge.setAttribute('multiplier', multiplier)
    }
  } catch (error) {
    throw error
  }

  

  productSaleDetails.querySelector('.loader').remove()
  productSaleDetails.prepend(productBadge)

  return true
}

function updateTotalPrice() {
  const productCards   = document.querySelectorAll('.product-card')
  const subtotalElement = document.querySelector('.cart-modal .payment-description .payment-subtotal .subtotal-price')
  let price = 0
  let totalPrice = 0

  for (let productCard of productCards) {
    let productPriceElement = productCard.querySelector('.product-price')
    let productPriceText = productPriceElement.innerText && productPriceElement.innerText.substring(1, productPriceElement.innerText.length)

    if (productPriceText.includes(',')) {
      productPriceText = productPriceText.replace(',', '')
    }

    price = parseFloat(productPriceText,10)

    totalPrice += price
  }

  subtotalElement.innerText = `$${totalPrice.toFixed(2)}`
}

function createCartSubmitInput() {
  const cartSubmitInput = document.createElement('input')

  cartSubmitInput.setAttribute('name', 'checkout')
  cartSubmitInput.setAttribute('type', 'hidden')
  document.querySelector('#cart').appendChild(cartSubmitInput)
}

function initCartPopoutDrawer() {
  if (!isIE()) {
    return
  }
  
  createCartSubmitInput()
}


async function adjustQuantity(variantId, operation, amount = 1, self) {
  const operations = ['add', 'subtract']
  const updateObj  = { updates: {} }
  let newQuantity  = 0
  let productVariant = null

  if (!operations.includes(operation)) {
    console.error('adjustQuantity can only take add or subtract for an operation')
  }

  const cart = await getCart()
  const product = cart.items && cart.items.find((item) => item.variant_id == variantId)

  if (operation === 'subtract') {
    newQuantity = parseInt(product.quantity, 10) - parseInt(amount, 10)
  } else {
    newQuantity = parseInt(product.quantity, 10) + parseInt(amount, 10)
  }

  if (newQuantity < 0) {
    newQuantity = 0
  }

  updateObj['updates'][variantId] = newQuantity
  let listIds = [variantId] 
  if (self) {
    const qtyBox = self.closest('.quantity-control').querySelector('.quantity-value')
    const handle = qtyBox.getAttribute('handle')
    listIds = [...document.querySelectorAll(`.quantity-value[handle="${handle}"]`)].map(item => +item.getAttribute('id'))
    listIds.forEach(id => {
      updateObj['updates'][id] = newQuantity
    })
  }

  const updatedCart = await updateCart(updateObj)
  productVariant = await getProductVariantInfo(variantId)
  updateCartPoints()
  updateRewardPoints()
  updateTotalPrice()
  
  for (let i = 0; i < listIds.length; i++ ){
    const id = listIds[i]
    const updatedProduct = updatedCart.items && updatedCart.items.find((item) => item.variant_id == id)
    updatedProduct.product = productVariant
    updateProductValues(id, updatedProduct, updatedCart)
  }
}

function updateProductValues(variantId, product, currentCart) {
  const productIdentifier  = '.product-variant-' + variantId
  const productCard        = document.querySelector(productIdentifier)
  const productQuantity    = document.querySelector(productIdentifier + ' ' + '.quantity-value')
  const productPoints      = document.querySelector(productIdentifier + ' ' + '.points-badge' + ' ' + '.point-value')
  const productPrice       = document.querySelector(productIdentifier + ' ' + '.product-price')
  const subTotalPrice      = document.querySelector('.subtotal-price')
  const checkoutBtn        = document.querySelector('#slider-checkout')
  let productOriginalPrice = document.querySelector(productIdentifier + ' ' + '.original-price') || null
  if (!product && productCard) {
    productCard.remove()
  }

  if (product && product.product && product.product.compare_at_price && product.product.compare_at_price != product.product.price) {
    let price = 0
    
    price = parseInt(product.quantity, 10) * parseFloat(product.product.compare_at_price, 10)
    
    if (productOriginalPrice) {
      productOriginalPrice.innerText = Shopify.formatMoney(price, Shopify.money_format)
    } else {
      productOriginalPrice = document.createElement('p')
      productOriginalPrice.setAttribute('class', 'original-price')
      productOriginalPrice.innerText = Shopify.formatMoney(price, Shopify.money_format)
      productPrice.parentElement.insertBefore(productOriginalPrice, productPrice)
    }
  }

  if (currentCart.items && currentCart.items.length === 0) {
    adjustContianerHeight(currentCart.items.length)
    checkoutBtn.setAttribute('disabled', true)
  } else {
    adjustContianerHeight(currentCart.items.length)
    checkoutBtn.removeAttribute('disabled')
  }

  productQuantity.innerText = product && product.quantity
  productPrice.innerText    = product && Shopify.formatMoney(product.final_line_price, Shopify.money_format)
  subTotalPrice.innerText   = Shopify.formatMoney(currentCart.total_price, Shopify.money_format)
  updateCartPoints()
  updateRewardPoints()
  updateTotalPrice()
}

function getFirstProductId() {
  let product   = document.querySelector('.product-card')
  let productId = null

  if (product) {
    productId = product.dataset && product.dataset.productid
  }

  return productId
}

function goToUrl(url) {
  location.href = url
}
async function addToCartForRecommendation(handle,varId) {
  const parentProduct = await getProductInfo(handle);
  const variantProduct = await getProductVariantInfo(varId)
  const productsDisplay = document.querySelector('.products-display')
  const loaderContainer = document.createElement('div')
  loaderContainer.setAttribute('class', 'loader-container')
  loaderContainer.innerHTML = `<span class='loader'></span>`
  productsDisplay.append(loaderContainer)
  const points = await getVariantPoints(varId)
  const multiplier = await getMultiplier();
  variantProduct.metafields = { ghs: { points, multiplier }}
  parentProduct.metafields = { ghs: { points, multiplier }}
  console.log("Recommendation adding product -->: ",parentProduct,variantProduct)

  await addProductToCart({ product: parentProduct, variant: variantProduct, variantId: varId, amount: 1, updateUiOnly: false, fromRecommend: true })
}

async function showRecommendations(productId){
  const productRecommendationsSection = document.querySelector('.recommendations');
    fetch(`/recommendations/products?product_id=${productId}&limit=4&section_id=product-recommendations`)
    .then(response => response.text())
    .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#hiddenRecommend');
        const loaderContainer = document.createElement('div')
          loaderContainer.setAttribute('class', 'loader-container')
          loaderContainer.innerHTML = `<span class='loader'></span>`
        productRecommendationsSection.append(loaderContainer);
        console.log(productRecommendationsSection,recommendations)
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
    });
}


async function getProductRecommendations(productId) {
  const track = document.querySelector('.recommendations .track')
  const multiplier = pointMultiplier
  const products = await getRecommendedProducts(productId)
  if (products){
    for (let product of products) {
      const miniProductCard = document.createElement('div')
      const points = await getVariantPoints(product.variants[0].id)
      miniProductCard.setAttribute('class', 'mini-product-card')
      miniProductCard.innerHTML = `
            <div class="mini-product-container">
              <div class="product-img-container" onClick="goToUrl('${product.url}')">
                <img src="https:${product.featured_image}" class="product-img" />
              </div>
              <div class="mini-product-details">
                <span class="mini-product-brand">${product.vendor}</span>
                <span class="mini-product-title" onClick="goToUrl('${product.url}')">${product.title}</span>
                <button class="gh-btn btn-size__sm btn-shape__pill btn-theme__primaryFilledLight" onClick="goToUrl('${product.url}')">View Product</button>
              </div>
              <div class="product-sale-details">
                ${product.compare_at_price && product.compare_at_price != product.price ? `<span class='sale-badge'>sale</span>` : product.tags.includes('nopoints') ? `<alt-points-badge points="0" multiplier="${multiplier}"></alt-points-badge>` : `<alt-points-badge points="${points}" multiplier="${multiplier}"></alt-points-badge>`}
                <div class="pricing">
                  ${getPriceHTML(product)}
                </div>
              </div>
            </div>
          `
  
      track.append(miniProductCard)
    }
  }
}

function getPriceHTML(item) {
  let priceHTML = ''

  if (item.product) {
    if (item.product.compare_at_price && item.product.compare_at_price != item.product.price) {
      priceHTML = `
        <p class="original-price">${Shopify.formatMoney(item.product.compare_at_price, Shopify.money_format)}</p>
        <p class="product-price">${Shopify.formatMoney(item.product.price, Shopify.money_format)}</p>
      `
    } else {
      priceHTML = `<p class="product-price">${Shopify.formatMoney(item.product.price, Shopify.money_format)}</p>`
    }
  } else {
    if (item.compare_at_price && item.compare_at_price != item.price) {
      priceHTML = `
        <p class="original-price">${Shopify.formatMoney(item.compare_at_price, Shopify.money_format)}</p>
        <p class="product-price">${Shopify.formatMoney(item.price, Shopify.money_format)}</p>
      `
    } else {
      priceHTML = `<p class="product-price">${Shopify.formatMoney(item.price, Shopify.money_format)}</p>`
    }
  }
  
  return priceHTML
}

async function addProduct(item) {
  const productsDisplay     = document.querySelector('.products-display')
  const existingProductCard = item && item.variant_id ? productsDisplay.querySelector('.product-variant-' + item.variant_id) : null
  const productCard         = document.createElement('div')
  const multiplier          = 1
  const points              = 1
  productCard.setAttribute('class', 'product-card')
  productCard.setAttribute('data-variantid', item.variant_id)
  productCard.setAttribute('data-productid', item.product_id)
  productCard.classList.add(`product-variant-${item.variant_id}`)
  let isAddon = false
  if (item.properties && item.properties['Main Product']) {
    isAddon = true;
  }

  const prdTitle = isAddon ? item.properties['Main Product'] : item.title
  const prdHandle = prdTitle.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

  const removeIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5 11H19V13H5V11Z" fill="#404040"/>
  </svg>`
  const addIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="#404040"/>
  </svg>`

  var htmlNewItem = `
  <div class="product-img-container">
    <img src="${item.image}" alt="${decodeURIComponent(item.image.alt)}" loading="lazy" class="product-img" />
  </div>
  <div class="detail-container ${isAddon ? 'hide-point' : '' }">
    <div class="product-details">
      <h3 class="product-title">${decodeURIComponent(item.product_title)}</h3>
      <div class="quantity-control ${isAddon ? 'disabled' : '' }">`;
        if(`${item.product_type}` != "Subscription"){
          htmlNewItem += `<span class="minus" onClick="adjustQuantity('${item.variant_id}', 'subtract', 1, this)">${removeIcon}</span>`;
        }
        htmlNewItem +=  `<span class="quantity-value" handle="${prdHandle}" id="${item.id}">${item.quantity}</span>`;
        if( `${item.product_type}` != "Subscription"){
          htmlNewItem += `<span class="plus" onClick="adjustQuantity('${item.variant_id}', 'add', 1, this)">${addIcon}</span>`
        }
      htmlNewItem +=  `</div>
        <p class="remove-chip ${isAddon ? 'disabled' : '' }" onClick="removeProduct(${item.variant_id}, this)"
        handle="${prdHandle}">Remove</p>
    </div>
    <div class="product-sale-details">
      ${currentCustomer && (currentCustomer.tags.includes('Insider') || currentCustomer.tags.includes('Insider_trial') || currentCustomer.tags.includes('Rewards') || currentCustomer.tags.includes('Explorer') || currentCustomer.tags.includes('Explorer_trial') || currentCustomer.tags.includes('Business_members') || currentCustomer.tags.includes('Insider_plus')) ? `<points-badge points="${points}" multiplier="${multiplier}"></points-badge>` : `<points-badge points="${points}" multiplier="${multiplier}" disabled="true"></points-badge>`}
      <div class="pricing">
        ${getPriceHTML(item)}
      </div>
    </div>
  </div>
`;
productCard.innerHTML = htmlNewItem

  if (!item.product_has_only_default_variant || (item.properties && item.properties.size && item.properties.size != 0) || item.selling_plan_allocation) {
    const quantityControl = productCard.querySelector('.quantity-control')
    const ul = document.createElement('ul')
    ul.setAttribute('class', 'variant-list')

    if (!item.product_has_only_default_variant) {
      for (let option of item.options_with_values) {
        if (option.value && option.name && option.value != 'undefined' && option.name != 'undefined') {
          const li = document.createElement('li')
          li.setAttribute('class', 'variant-title')
          li.innerText = `${option.name}: ${option.value}`

          ul.append(li)
        }
      }
    }
    
    if (isAddon) {
      const li = document.createElement('li')
      li.setAttribute('class', 'variant-title')
      li.innerText = `Main Product: ${item.properties['Main Product']}`
      ul.append(li)
    }

    quantityControl.parentElement.insertBefore(ul, quantityControl)
  }

  if (existingProductCard) {
    productsDisplay.querySelector('.loader-container') && productsDisplay.querySelector('.loader-container').remove()
    return
  } else {
    productsDisplay.querySelector('.loader-container') && productsDisplay.querySelector('.loader-container').remove()
    // productsDisplay.append(productCard)
    document.querySelector('.products-display form').append(productCard)
    updateCartPoints()
    const productPointsUpdated = await updateProductPoints(item.variant_id, item.product.tags, item.product.metafields)
    if (productPointsUpdated) {
      updateRewardPoints()
    }
    updateTotalPrice()
  }
    const relatedEl = document.querySelectorAll(`[handle=${prdHandle}]`);
    if(relatedEl.length > 2){
      const mainRelated = relatedEl[0];
      mainRelated.parentElement.classList.add('disabled');
    }

}

async function addProductToCart({ product, variant, variantId, amount = 1, updateUiOnly = false, fromRecommend = false }) {
  let currentCart = null
  let updatedCart = null
  let updatedProduct = null
  if(!fromRecommend){
    try {
      currentCart = await getCart();
      updatedProduct = currentCart && currentCart.items && currentCart.items.find((item) => item.variant_id == variantId)
      updatedProduct.product = variant
      updatedProduct.product.tags = product ? product.tags.join(',') : ''
      updatedProduct.product.metafields = variant.metafields
    } catch (error) {
      throw error
    }
  }
  if (!updateUiOnly) {
    let cartObj      = { items: [] }
    let productToAdd = { id: variant.id, quantity: parseInt(amount, 10) }
    cartObj.items.push(productToAdd)
    await postToCart(cartObj)
    updatedCart = await getCart();
    updatedProduct = updatedCart && updatedCart.items.find((item) => item.variant_id == variantId)
    updatedProduct.product = variant
    if(fromRecommend){
      updatedProduct.product.tags = product.tags
      updatedProduct.product.metafields = variant.metafields
    }
  }
  addProduct(updatedProduct)
  updateProductValues(variantId, updatedProduct, updatedCart ? updatedCart : currentCart)
  //await getProductRecommendations(updatedProduct.product_id)
}


(async function() {
  initCartPopoutDrawer()
  // await getProductRecommendations(getFirstProductId())
  attachEventListeners()
})();
